import React, {useEffect, useState} from "react";
import "../surveyAdherence.css";
import {firestore} from "../../utils/firebase";

import {Col, Table} from "react-bootstrap";

const CmReportTable005A99Ind = (props) => {
    const {tableKey} = props;
    const {bgColor}  = props;
    // const {tdFontSize}  = props;
    const {thFontSize}  = props;
    const [tableDoc, setTableDoc] = useState();
    const [name, setName] = useState("");
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        firestore
            .doc("analytics/reports/reportTables005/" + tableKey)
            .get()
            .then((doc) => {
                const data = doc.data();
                setColumns(data.columns);
                setName(data.name);
                setTableDoc(doc);
                const path = data.collectionPath ? data.collectionPath : "analytics/reports/reportTables005/" + tableKey + "/rows";
                let query = data ? firestore
                .collection(path)
                .orderBy(data.orderBy.field, data.orderBy.direction) : firestore.collection(path);
                query = data?.orderBy2? query.orderBy(data.orderBy2.field, data.orderBy2.direction) : query;
               
                query.onSnapshot((snap) => {
                    setRows(snap.docs);
                });
            });
    }, [tableKey]);

    const getTableRow = (progRef) => {
        let data = progRef.data();

        let cols = columns.map((c) => {
            let val = data[c];
            if (typeof data[c] === "object") {
                try {
                    val = data[c].toDate().toISOString().slice(0,10);
                } catch (error) {
                    console.log('couldnt format something', {data, error})
                }
            }
            return <td   >{val}</td>;
        });
        return (<tr className={"blankTwo"} key={progRef.id} onClick={() => {
            }}>
                {cols.slice(1,)}
            </tr>);
    };
    if (!(columns && rows)) {
        return <> </>;
    }
    return (<>

{/* ,paddingLeft: "5px",paddingRight: "3px",paddingBottom: "0px"  */}

            <Col  xs={12}>
                <Table className={"blankTwo"}  style={{backgroundColor: "white", width: "auto"}}>
                    
                    <thead  key={"tableHead" + (tableDoc ? tableDoc.id : "")}>
                    <tr class={"blankTwo"} style={{backgroundColor: bgColor}}  key={"headerRow"} >
                        
                        {columns.slice(1,).map((c) => {
                            return <th className={"blankTwo"} style={{color:"#FFF9F3", fontSize: thFontSize, paddingLeft: "10px",paddingRight: "10px",lineHeight: "1"}} key={c.id}>{c}</th>;
                        })}
                    </tr>
                    </thead>
                    <tbody  className={"blankTwo"}  >{rows.map((u) => getTableRow(u))}</tbody>
                </Table>
            </Col>

        </>);
};

export default CmReportTable005A99Ind;

